import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import HeaderComp from 'components/layout/Header';
import Footer from 'components/layout/Footer';
import { get100vhHeight } from 'styles/mixins';
import PciFooter from 'components/layout/PciFooter';
import TypesDropdown from 'components/widgets/TypesDropdown/TypesDropdownNew';

export const Wrapper = styled.div<{ isPreview?: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  min-height: 100vh;
  height: fit-content;

  ${({ theme, isPreview }) => {
    const { isMobile, isSdk } = theme.view;

    if (isSdk) {
      return css`
        min-height: unset;
        background: unset;
      `;
    }

    if (isMobile) {
      return css`
        ${get100vhHeight('height')}
        ${get100vhHeight('min-height')}
        width: auto;
        min-width: unset;
        ${isPreview &&
        css`
          height: 100%;
        `};
      `;
    }

    if (!isSdk && !isMobile) {
      return css`
        max-width: 113rem;
        min-width: fit-content;
        padding: 0 2rem;
        margin: auto;
        ${isPreview &&
        css`
          height: 100%;
          padding-top: 0.2rem;
        `}
      `;
    }
  }}
`;

export const Header = styled(HeaderComp)<{ isPreview: boolean }>`
  top: 0;
  z-index: 10;

  ${({ theme }) =>
    theme.view.isMobile &&
    css`
      position: sticky;
      box-shadow: 0 1.4rem 4rem rgb(0 0 0 / 7%);
    `}
`;

const contentStyle = css`
  flex: 1;
  display: flex;
  align-self: center;
  flex-flow: column nowrap;
  ${({ theme }) =>
    theme.view.isSdk &&
    css`
      width: 100%;
    `}
`;

export const Content = styled.div`
  ${contentStyle};
`;

export const CheckoutContent = styled.div`
  ${contentStyle};
  width: 100%;
`;

const PageContentDiv = styled.div`
  flex: 1;
  width: 100%;

  ${({ theme }) => {
    const { isMobileNotSdk } = theme.view;

    if (isMobileNotSdk) {
      return css`
        flex: 1;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      `;
    }
  }}
`;

export const PageContent = ({
  dataTestId,
  className,
  children
}: {
  dataTestId?: string;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <PageContentDiv className={className} data-testid={dataTestId || 'page-box'}>
      {children}
    </PageContentDiv>
  );
};

const FooterWrapper = styled.div`
  width: 100%;
  bottom: 0;
  padding-bottom: 2rem;

  ${({ theme }) => {
    const { isMobileNotSdk } = theme.view;

    if (isMobileNotSdk) {
      return css`
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      `;
    }
  }}
`;

interface IProps {
  withPci?: boolean;
}

export const FooterComponent = ({ withPci }: IProps) => {
  return (
    <FooterWrapper data-testid="footer-wrapper">
      {withPci ? <PciFooter /> : <Footer />}
    </FooterWrapper>
  );
};

export const FIELD_SPACING = '1.5rem';

export const fieldsWrapperStyle = css`
  > *:not(:last-child) {
    margin-bottom: ${FIELD_SPACING};
  }
`;

export const FieldsWrapper = styled.div`
  ${fieldsWrapperStyle};
`;

export const StyledTypesDropdown = styled(TypesDropdown)`
  margin-bottom: 1rem;
`;

export const BoxWidthAndMargins = css`
  width: ${({ theme }) => (theme.view.isMobile || theme.view.isSdk ? '100%' : '45rem')};
  padding-right: ${({ theme }) => (theme.view.isMobile ? '1.5rem' : '4.8rem')};
  padding-left: ${({ theme }) => (theme.view.isMobile ? '1.5rem' : '4.8rem')};
`;
